import { group, query, transition, trigger } from '@angular/animations';

import { AnimationTransition, applyFadeInAnimation, applyFadeInTranslateAnimation, applyFadeOutAnimation } from '../../core/animations';

export const VendorChatExplainerModalPageAnimations = [
  trigger('animatedChatExplainer', [
    transition(
      AnimationTransition.VoidToAny,
      group([
        query(':self', applyFadeInAnimation({ duration: 300, delay: 300 })),
        query('.animated-title', applyFadeInTranslateAnimation({ duration: 300, delay: 600, distance: '-10px' })),
        query('.animated-description', applyFadeInTranslateAnimation({ duration: 450, delay: 650, distance: '-10px' })),
        query('.animated-illustration', applyFadeInTranslateAnimation({ duration: 600, delay: 700, distance: '-10px' })),
      ]),
    ),
    transition(AnimationTransition.AnyToVoid, applyFadeOutAnimation({ duration: 300 })),
  ]),
];
